// API Configuration
// Direct API calls without proxy (backend CORS is now properly configured)

const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

// Always use full URLs now that backend CORS is fixed
const API_BASE = process.env.REACT_APP_API_BASE_URL || 'https://api-dev.mcd.cxsandbox.com';
const AI_ANALYSIS_BASE = 'https://qa-agent.cxsandbox.com';
const SCENARIOS_DISPATCHER_URL =
  ENVIRONMENT === 'local' ? process.env.REACT_APP_SCENARIOS_DISPATCHER_URL : API_BASE;

const QA_BACKEND_URL = ENVIRONMENT === 'local' ? process.env.REACT_APP_QA_BACKEND_URL : API_BASE;

const LOCATOR_DRIFT_URL = `${SCENARIOS_DISPATCHER_URL}/locatorDrift`;

const AI_AGENTS_URL = `${SCENARIOS_DISPATCHER_URL}/agent`;

export const API_ENDPOINTS = {
  // Flow endpoints
  INSERT_TEST_FLOW: `${QA_BACKEND_URL}/insert-test-flow`,
  UPDATE_TEST_FLOW: `${QA_BACKEND_URL}/update-test-flow`,
  GET_TEST_FLOWS: `${QA_BACKEND_URL}/get-test-flows`,
  GET_TEST_FLOW_DATA: `${QA_BACKEND_URL}/get-test-flow-data`,
  DELETE_ATTRIBUTE: `${QA_BACKEND_URL}/delete-attribute`,
  DELETE_SCENARIO: `${QA_BACKEND_URL}/delete-scenario`,
  DELETE_EVENT_OR_FLOW: `${QA_BACKEND_URL}/delete-testflow-event`,

  // Schema endpoints
  SCHEMAS: `${QA_BACKEND_URL}/schemas`,
  CREATE_EVENT_FROM_SCHEMA: `${QA_BACKEND_URL}/test-events/from-schema`,
  SAVE_CUSTOM_VALUES: `${QA_BACKEND_URL}/test-events/custom-values`,

  // Markets endpoint
  GET_MARKETS: `${QA_BACKEND_URL}/get-markets`,

  // Device endpoints
  GET_DEVICES: `${QA_BACKEND_URL}/get-devices`,
  INSERT_DEVICE: `${QA_BACKEND_URL}/insert-device-data`,
  UPDATE_DEVICE: `${QA_BACKEND_URL}/update-device`,
  DELETE_DEVICE: `${QA_BACKEND_URL}/delete-device`,

  // Regression test results endpoints
  UPLOAD_REGRESSION_FILE: `${QA_BACKEND_URL}/upload-regression-file`,
  EXPORT_TO_CONFLUENCE: `${QA_BACKEND_URL}/export-to-confluence`,
  GET_REGRESSION_TEST_RESULT: `${QA_BACKEND_URL}/get-regression-test-result`,

  // Validation endpoints
  GET_EVENTS_FOR_VALIDATION: `${QA_BACKEND_URL}/get-events-for-validation`,

  // Regression test ID endpoint
  // GET_REGRESSION_TEST_IDS: `${QA_BACKEND_URL}/get-regression-test-id`,
  GET_REGRESSION_TEST_IDS: `${QA_BACKEND_URL}/get-regression-tests`,

  // confluence url endpoint
  GET_CONFLUENCE_URL: `${QA_BACKEND_URL}/get-confluence-url`,

  //BUG REPORT endpoint
  REPORT_BUG: `${QA_BACKEND_URL}/bug-reports`,

  // E2E endpoints
  GET_APP_FLOWS: (marketId) => `${SCENARIOS_DISPATCHER_URL}/flows?market_id=${marketId}`,
  GET_ACTIVE_RUNS: `${SCENARIOS_DISPATCHER_URL}/runs/active`,
  GET_RUN_HISTORY: `${SCENARIOS_DISPATCHER_URL}/runs/history`,
  GET_RUN_SUMMARY: `${SCENARIOS_DISPATCHER_URL}/runs/history/summary`,
  GET_FAILED_RUNS: `${SCENARIOS_DISPATCHER_URL}/runs/history/failures`,
  GET_RUNS_BUILD_VERSIONS: `${SCENARIOS_DISPATCHER_URL}/runs/history/summary/buildVersions`,
  RUN_SUMMARY_EXPORT: `${SCENARIOS_DISPATCHER_URL}/runs/history/export`,
  RUN_MULTIPLE_SCENARIOS: `${SCENARIOS_DISPATCHER_URL}/runs/multiple-scenarios`,
  RUN_SCENARIO: `${SCENARIOS_DISPATCHER_URL}/runs/run-scenario`,
  CANCEL_RUN: (runId) => `${SCENARIOS_DISPATCHER_URL}/runs/${runId}/cancel`,
  CANCEL_ALL_RUNS: `${SCENARIOS_DISPATCHER_URL}/runs/cancel-all`,
  CHECK_APPIUM_CONNECTION: `${SCENARIOS_DISPATCHER_URL}/appium/check-connection`,
  QUEUE_STATUS: `${SCENARIOS_DISPATCHER_URL}/runs/queue-status`,
  GET_RUN_LOGS: (runId) => `${SCENARIOS_DISPATCHER_URL}/runs/${runId}/logs`,
  GET_RUN_SCREENSHOT: (runId) => `${SCENARIOS_DISPATCHER_URL}/runs/${runId}/screenshot`,

  //update notes
  UPDATE_REGRESSION_TEST_RESULT_DATA: `${QA_BACKEND_URL}/update-regression-test-result-data`,

  // Setup kit
  DOWNLOAD_SETUP_KIT: `${SCENARIOS_DISPATCHER_URL}/setup/download`,

  // Regression test CRUD endpoints
  GET_ALL_REGRESSION_TESTS: `${QA_BACKEND_URL}/get-regression-tests`,
  CREATE_REGRESSION_TEST: `${QA_BACKEND_URL}/insert-regression-test`,
  UPDATE_REGRESSION_TEST: `${QA_BACKEND_URL}/update-regression-test`,
  DELETE_REGRESSION_TEST: `${QA_BACKEND_URL}/delete-regression-test`,

  //AI Analysis endpoint
  AI_ANALYZE: (id) => `${AI_ANALYSIS_BASE}/analyze/${id}`,

  // Locator Drift dashboard endpoints
  LOCATOR_DATA: `${LOCATOR_DRIFT_URL}/locator-data`,
  LOCATOR_DATA_FILE: (filename) =>
    `${LOCATOR_DRIFT_URL}/locator-data/${encodeURIComponent(filename)}`,
  LOCATOR_DATA_GROUPED: `${LOCATOR_DRIFT_URL}/locator-data/grouped`,
  PAGE_SOURCE_FILE: (filename) =>
    `${LOCATOR_DRIFT_URL}/page-source/${encodeURIComponent(filename)}`,
  BEACON_PRIORITIES: `${LOCATOR_DRIFT_URL}/beacon-priorities`,
  DRIFT_IGNORE: `${LOCATOR_DRIFT_URL}/drift-ignore`,
  COMPARE_SCREEN_DRIFT: `${LOCATOR_DRIFT_URL}/compare/screen`,
  BEACON_DATA_GROUPED: `${LOCATOR_DRIFT_URL}/beacon-data/grouped`,
  COMPARE_ANALYTICS_DRIFT: `${LOCATOR_DRIFT_URL}/compare/analytics`,
  COMPARE_VERSION_DIFF: `${LOCATOR_DRIFT_URL}/compare/version-diff`,
  HEALING_STATS: `${LOCATOR_DRIFT_URL}/healing-stats`,
  HEALING_HISTORY: (options = {}) => {
    const normalized = typeof options === 'number' ? { limit: options } : options;
    const params = new URLSearchParams();
    params.set('limit', String(normalized.limit ?? 50));
    if (normalized.sort) {
      params.set('sort', normalized.sort);
    }
    if (typeof normalized.hideLowSignal === 'boolean') {
      params.set('hide_low_signal', normalized.hideLowSignal ? 'true' : 'false');
    }
    return `${LOCATOR_DRIFT_URL}/healing-history?${params.toString()}`;
  },
  HEALING_HISTORY_ITEM: (eventId) => `${LOCATOR_DRIFT_URL}/healing-history/${eventId}`,
  HEAL_RUN: `${LOCATOR_DRIFT_URL}/heal/run`,

  // Start unused Locator Drift scenario runner endpoints.
  // Retained for the non-batch runner flow, although the current LocatorDriftPage UI does not render it.
  LOCATOR_DRIFT_HEALTH: `${SCENARIOS_DISPATCHER_URL}/health`,
  LOCATOR_DRIFT_FLOWS: `${SCENARIOS_DISPATCHER_URL}/flows`,
  LOCATOR_DRIFT_RUN_SCENARIO: (flowId, scenarioId) =>
    `${SCENARIOS_DISPATCHER_URL}/flows/${encodeURIComponent(flowId)}/scenarios/${encodeURIComponent(scenarioId)}/run`,
  LOCATOR_DRIFT_RUN: (runId) => `${SCENARIOS_DISPATCHER_URL}/runs/${runId}`,
  LOCATOR_DRIFT_RUN_LOGS: (runId, fromIndex = 0) =>
    `${SCENARIOS_DISPATCHER_URL}/runs/${runId}/logs?from_index=${fromIndex}`,
  // End unused Locator Drift scenario runner endpoints.

  // Locator management endpoints (dev mode)
  LOCATORS_SEARCH: `${SCENARIOS_DISPATCHER_URL}/locators/search`,
  LOCATORS_CREATE: `${SCENARIOS_DISPATCHER_URL}/locators/create`,
  LOCATORS_UPDATE: (id) => `${SCENARIOS_DISPATCHER_URL}/locators/update/${id}`,
  LOCATORS_PAGES: `${SCENARIOS_DISPATCHER_URL}/locators/pages`,

  // AI AGENTS URL
  ANALYZE_BUG: `${AI_AGENTS_URL}/analyze-bug`,
  CREATE_JIRA_TICKET: `${AI_AGENTS_URL}/create-jira-ticket`,
  RUN_SUMMARY_AGENT: `${AI_AGENTS_URL}/run-summary-report`,
  SUMMARIZE_REGRESSION: (id) => `${AI_AGENTS_URL}/beacon/summarize-regression/${id}`,
  SUMMARIZE_FLOW: (id) => `${AI_AGENTS_URL}/beacon/summarize-flow/${id}`,
  CREATE_EVENT_FAILURE_TICKETS: `${AI_AGENTS_URL}/event-failure-tickets`,
  EVENT_FAILURE_TICKETS_STATUS: (jobId) =>
    `${AI_AGENTS_URL}/event-failure-tickets/status/${encodeURIComponent(jobId)}`,
};

export default API_ENDPOINTS;
